<!-- <div class="clientarea" [ngStyle]="{ 'height.px': clientHeight }"> -->
<!-- <div class="clientarea" style="height: 1137px;"> -->
<div class="clientarea" style="height: 100%;">
  <div class="buttonline" #buttonline>
    <div class="left">
      <!-- <h1>{{title}}</h1> -->
      <!-- <h4 style="margin-top: 5px;"><b>{{title}}</b></h4> -->
    </div>
    <div class="right">
      <button mat-button (click)="reload()" title="Aktualisieren">
        <i class="material-icons">refresh</i>Aktualisieren
      </button>
      <button *ngIf="!is_deleteUsedFiles" mat-button (click)="onDeleteRead()" title="Verwendete Dateien löschen" [disabled]="files.length<1">
        <i class="material-icons">delete_sweep</i>Löschen
      </button>
      <ng-container *ngIf="isMultiselect">
        <div class="separator_10"></div>
        <button mat-button (click)="applySelection()" title="Auswahl anwenden ({{countSelected()}} selektiert)"
          [disabled]="countSelected()<1">
          <div class="buttonContent">
            <i class="material-icons icongreen">play_circle</i>
            <div class="actionArea">
              <span>Anwenden</span>
            </div>
          </div>
        </button>
      </ng-container>

    </div>
  </div>

  <!--   <app-chunkedFileUpload [title]="'Test123'"></app-chunkedFileUpload> -->

  <div class="content scrollarea" >
    <div class="waitpanel" *ngIf="!files"></div>
    <div *ngIf="files">
      <app-file *ngIf="isMultiselect"
        [isHeader]="true"
        [isMultiselect]="true"
        [filesLength]="files.length"
        (onAllSelect)="toggleSelectAll()"
        (onAllDelete)="deleteAll()"
        (onAllDownload)="downloadAll()"
        >
      </app-file>
      <ng-container *ngFor="let file of files">
        <app-file *ngIf="isFileSupported(file)" 
          [userEmail]="userEmail"
          [isHeader]="false"
          [file]="file" 
          [selectedFile]="selectedInfo" 
          [folder]="folder"
          [isMultiselect]="isMultiselect" 
          (onDelete)="onDelete($event)" 
          (onClick)="onClick($event)"
          (onFirstDownload)="onFirstDownload($event)"
          #fileItems>
        </app-file>
      </ng-container>
    </div>
  </div>
  <div class="uploadArea" #uploadarea>
    <app-fileuUploadArea *ngIf="isUploadAllowed" [title]="title" [filetypes]="filetypes"
      (setFileInfo)="onSetFileInfo($event)" (setCountRunningUploads)="onSetCountRunningUploads($event)"></app-fileuUploadArea>
  </div>
</div>
